import { render } from "./CustomersPage.vue?vue&type=template&id=ebd4389e&scoped=true"
import script from "./CustomersPage.vue?vue&type=script&lang=js"
export * from "./CustomersPage.vue?vue&type=script&lang=js"

import "./CustomersPage.vue?vue&type=style&index=0&id=ebd4389e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd4389e"]])

export default __exports__